// Raw values, in pixels
const spacingValues = {
  none: 0,
  micro: 4,
  mini: 6,
  small: 10,
  base: 14,
  medium: 18,
  large: 22,
  xlarge: 26,
  xxlarge: 44
};
const spacing = {};
Object.keys(spacingValues).forEach(key => {
  spacing[key] = `${spacingValues[key]}px`;
});
const mobileSpacingValues = {
  none: 0,
  micro: 6,
  mini: 10,
  small: 14,
  base: 18,
  medium: 22,
  large: 26,
  xlarge: 44,
  xxlarge: 44
};
const mobileSpacing = {};
Object.keys(mobileSpacingValues).forEach(key => {
  mobileSpacing[key] = `${mobileSpacingValues[key]}px`;
});

export { spacingValues as a, mobileSpacingValues as b, mobileSpacing as m, spacing as s };
//# sourceMappingURL=spacing-zNVNrnl_.js.map
